import { Config } from "@/shared/config";

const uri = Config.Advisor3ServicebaseUri;

export default {
  get advisor () {
    return document.location.hostname.indexOf(".bendhsademo.com") > -1
    ? `${uri}/advisor-mock/v1`
    : `${uri}/advisor/v1`;
  },
  actionById (actionId: number): string {
    return `${this.advisor}/action/${actionId}`;
  },
  action (): string {
    return `${this.advisor}/action`;
  },
  rule (): string {
    return `${this.advisor}/rule`;
  },
  ruleById (id: number) {
    return `${this.advisor}/rule/${id}`;
  },
  rulePreview (): string {
    return `${this.advisor}/rule/preview`;
  },
  media (actionId: number, filename?: string) {
    if (filename) {
      return `${this.advisor}/action/${actionId}/media/${filename}`;
    }

    return `${this.advisor}/action/${actionId}/media`;
  },
  mediaS3PreSignedUrl (actionId: number, filename?: string) {
      return `${this.advisor}/action/download-link/${actionId}/media/${filename}`;
  },
  render () {
    return `${this.action()}/render`;
  },
  previewTemplate () {
      return `${this.action()}/preview-template`;
  },
  getAdvice (): string {
    return `${this.advisor}/advice`;
  },
  getAdviceLastUpdated (): string {
    return `${this.advisor}/advice/last-updated`;
  },
  saveEvent (): string {
    return `${this.advisor}/event`;
  },
  dismissAdvice (adviceId: string, executionId: number): string {
    return `${this.advisor}/advice/${adviceId}/dismiss/${executionId}`;
  },
  saveActionHistory (): string {
    return `${this.advisor}/advicehistory`;
  },
  getMessage (messageId: string): string {
      return `${this.advisor}/message-center/${messageId}`;
  },
  getDocument (documentId: number): string {
    return `${this.advisor}/message-center/document/${documentId}`;
  },
  getFilteredMessages (): string {
      return `${this.advisor}/message-center/get-filtered-messages`;
  },
  updateMessage (): string {
      return `${this.advisor}/message-center/update-message-label`;
  },
  markMessageReadValue (messageId: string, isRead: boolean): string {
    return `${this.advisor}/message-center/${messageId}/read/${isRead}`;
  },
};